/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project = feature.project;

    const printLinks = project.getNodeLinks(feature, 'digital_line_set');
    const newline = '+ "\\r\\n"';
    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    for (let i = 0; i < printLinks.length; i += 1) {
        const link = printLinks[i];
        const source = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        const lineNumber = project.parseCodeExpression(feature.getSettingValue('LINE_NUMBER'), sourceParams, TibboDataType.STRING);
        const value = project.parseCodeExpression(feature.getSettingValue('VALUE'), sourceParams, TibboDataType.STRING);

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
io.lineset(${lineNumber}, ${value})
${doneBlock}`,
        });
    }

    return blocks;
};
